import React from "react";

export const Layout = ({ children }) => {
  return <div className="layout">
    {children}
    <ins className="adsbygoogle"
      style={{display:"block"}}
      data-ad-client="ca-pub-7319445879423462"
      data-ad-slot="3548705180"
      data-ad-format="auto"
      data-full-width-responsive="true"
    ></ins>
  </div>;
};
